import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_CUSTOMER_UPGRADE_REQUEST } from './schema';

const MUTATION = gql`
  mutation RequestCustomerUpgrade(
    $customerId: Int!
    $userName: String!
    $selectedPlan: String!
    $requestCOAccess: Boolean
  ) {
    requestCustomerUpgrade(
      customerId: $customerId
      userName: $userName
      selectedPlan: $selectedPlan
      isContinuousOptimizationRequested: $requestCOAccess
    ) {
      ...CustomerUpgradeRequest
    }
  }
  ${FRAGMENT_CUSTOMER_UPGRADE_REQUEST}
`;

export function requestCustomerUpgrade(
  customerId,
  { userName, selectedPlan, requestCOAccess }
) {
  const variables = {
    customerId,
    userName,
    selectedPlan,
    requestCOAccess,
  };

  return apolloClient
    .mutate({
      mutation: MUTATION,
      variables,
    })
    .then(({ data }) => getSingleProp(data));
}
